
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";



import {ImageControlOptions} from "./ImageControl.Options";

import * as React from "react";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {ButtonProperties} from "InternalShared/PageBuilder/Controls/Properties/ButtonProperties";
import {FieldsProperty} from "InternalShared/PageBuilder/Controls/Properties/FieldsProperty";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {ImageProperty} from "InternalShared/PageBuilder/Controls/Properties/ImageProperty";
import {TextProperty} from "InternalShared/PageBuilder/Controls/Properties/TextProperty";
import {SimpleTextProperty} from "InternalShared/PageBuilder/Controls/Properties/SimpleTextProperty";
import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {CheckBoxProperty} from "InternalShared/PageBuilder/Controls/Properties/CheckBoxProperty";





declare let rednaoPDFInvoiceParams:any;
export class ImageControl extends PDFControlBase{

    public media:any;
    public Image:HTMLImageElement;
    public AllowedResizeDirection: AllowedResizeDirection = "both";
    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this)

            ];
    }
    public Options:ImageControlOptions;
    private properties:GroupProperties[];


    InternalAfterResize() {
        this.AdjustSize();
    }

    SetInitialStyles() {
        super.SetInitialStyles();
    }

    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return {text:''};
    }

    protected InternalGenerateHtml($container: JQuery) {
        this.Image=document.createElement('img') as HTMLImageElement;
        $container.append(this.Image);
        this.Image.src=this.Options.URL;
        this.AdjustSize();



    }

    private AdjustSize(){
        this.Image.style.width=parseFloat(this.Options.Styles.Width)+'px';
        this.Image.style.height=parseFloat(this.Options.Styles.Height)+'px';
    }


    public GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {

            this.properties=[new GroupProperties('General')
                .AddProperties([
                    new ImageProperty(this,'URL').SetLabel('Image').Focus(),
                    rednaoVar.IsDesignMode=='1'?new SimpleTextProperty(this,'TemplateFieldName').SetLabel('Template field name'):null,
                    (rednaoVar.IsDesignMode=='1'?new CheckBoxProperty(this,'HideFromTemplateDesigner').SetLabel('Hide from template designer'):null)
                ])];
        }

        return this.properties;
    }


    public AfterRefresh() {

    }

    GetInitialOptions(): Promise<any> {
        return new Promise(resolve => {


            if(this.media==null)
            {
                this.media = (window as any).wp.media({
                    title: "Which image do you want to use in your pdf?",
                    multiple: false,
                    button: {
                        text: 'Select an image'
                    }
                });



                this.media.on('escape',()=>{
                    resolve(null);

                });
                this.media.on('select',  ()=> {
                    let selection = this.media.state().get('selection');
                    console.log(selection);
                    if (selection == null)
                        return;

                    selection.each((attachment) =>{
                        let url=attachment.attributes.url;
                        let urlid=attachment.attributes.id;
                        resolve(new ImageControlOptions().Merge({
                            Styles:{
                                Width:200,
                                Height:200
                            },
                            URL:url,
                            URLId:urlid
                        }));
                    });

                });
            }

            this.media.open();
        });
    }

    private GenerateTable(container:HTMLElement) {


    }

    protected InternalGetLabel() {
        return 'Image';
    }

    GetValueEditor(): PropertyBase {
        return new ImageProperty(this,'URL').SetLabel('').SetWidth(100);
    }
}
